export default __webpack_public_path__ + "static/media/header-4.d11b8c26.jpg";